import useRouteHandle from "@/components/Root/hooks/useRouteHandle";
import UILoader from "@/components/ui/Loader";
import useControlIntercom from "@/hooks/useHideIntercom";
import { Outlet } from "@/lib/router";
import { usePageTracking } from "@/tracking/usePageTracking";
import { useSigninCheck } from "reactfire";

export const GalleryLayout = () => {
  const { status } = useSigninCheck();
  const { hideIntercom } = useRouteHandle();

  useControlIntercom(hideIntercom === true);
  usePageTracking();

  if (status === "loading") {
    return <UILoader />;
  }

  return <Outlet />;
};
